module.exports = {"id":"137677","name":"Michel Vorm","rating":"78","photo":"./data/images/photos/0/137677.png","club":{"name":"Tottenham Hotspur","logo":"./data/images/clubs/TottenhamHotspur.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MichelVorm0.json
// module id = 2999
// module chunks = 0